import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface GetProductCategoriesApiParameter extends ApiParameter {
    ProductIds: Array<string>;
}
const getProductUrl = "api/v1/productproperties";
export function submitGetProductCategories(parameter: GetProductCategoriesApiParameter) {
    return post<GetProductCategoriesApiParameter>(`${getProductUrl}`, { ProductIds: parameter.ProductIds as any });
}
